// removed by extract-text-webpack-plugin
module.exports = {"Content":"LayoutPrematch__Content__v_JCA","mainContainer":"LayoutPrematch__mainContainer__8L_1r","containerLeftSection":"LayoutPrematch__containerLeftSection__3Ut0l","containerMiddleSection":"LayoutPrematch__containerMiddleSection__3JGdX","containerRightSection":"LayoutPrematch__containerRightSection__34rgR","extraBetsContainer":"LayoutPrematch__extraBetsContainer__1hpnZ","showExtraBetsContainer":"LayoutPrematch__showExtraBetsContainer__3PdS5","hideExtraBetsContainer":"LayoutPrematch__hideExtraBetsContainer__1w87g","adminTapDetector":"LayoutPrematch__adminTapDetector__2LDFZ"};


//////////////////
// WEBPACK FOOTER
// ./src/HOCs/LayoutPrematch/LayoutPrematch.css
// module id = 436
// module chunks = 0